import React, { useEffect, useState } from 'react';

import { cn, ia } from 'lib/helpers/utility';

import Icon from '../Icon/Icon';
import InputOptions from '../InputOptions/InputOptions';
import ActionButton from '../shared/ActionButton';
import Header from '../shared/Header';
import Hint from '../shared/Hint';

import RightComponents from './components/RightComponents';
import { getCommonInputProps } from './lib/utils';

/**
 * @param {import('./lib/propTypes').InputProps} props
 */

const Input = (props) => {
  const {
    focusOnMount,
    forwardedRef,
    options,
    units,
    currentUnit,
    unitPanelClassName,
    onUnitChange,
    hint,
    hintIcon,
    error,
    isHeader,
    headerClassName,
    label,
    labelClassName,
    transcribing,
    additionalComponents,
    headerIcon,
    tooltip,
    isOptional,
    disabled,
    required,
    value,
    onChange,
    setDisabled,
    name,
    id,
    actionButtonText,
    actionButtonIcon,
    actionButtonClick,
    actionButtonClassName,
    errorClassName
  } = props;
  const [localError, setLocalError] = useState(null);
  const activeError = error || localError || null;

  // Get common props
  const { className, style, inputProps, wrapperProps, iconProps, showNumberControls } =
    getCommonInputProps({ ...props, activeError, setLocalError });

  useEffect(() => {
    if (focusOnMount && forwardedRef?.current) {
      forwardedRef.current.focus();
    }
  }, []);

  const rightComponentsProps = {
    ...props,
    rightIcon: iconProps.rightIcon,
    rightIconColor: iconProps.rightIconColor,
    rightIconClick: iconProps.rightIconClick,
    rightIconSize: iconProps.rightIconSize,
    disabled
  };

  return (
    <div className={className} style={style}>
      <Header
        isHeader={isHeader}
        headerClassName={headerClassName}
        label={label}
        labelClassName={labelClassName}
        transcribing={transcribing}
        additionalComponents={additionalComponents}
        icon={headerIcon}
        options={options}
        tooltip={tooltip}
        isOptional={isOptional}
        disabled={disabled}
        required={required}
        value={value}
        onChange={onChange}
        setDisabled={setDisabled}
        name={name}
        id={id}
      />
      <label {...wrapperProps} htmlFor={id}>
        <div className="flex grow items-center justify-between gap-x-2">
          {(iconProps.leftIcon || showNumberControls) && (
            <Icon
              htmlFor={id}
              disabled={disabled}
              icon={iconProps.leftIcon}
              onClick={iconProps.leftIconClick}
              size={iconProps.iconSize}
            />
          )}
          <input {...inputProps} />
          {ia(units) && (
            <InputOptions
              options={units}
              currentOption={currentUnit}
              onClickOption={onUnitChange}
              disabled={disabled}
              panelClassName={unitPanelClassName}
            />
          )}
        </div>
        <RightComponents {...rightComponentsProps} />
        <ActionButton
          text={actionButtonText}
          icon={actionButtonIcon}
          onClick={actionButtonClick}
          className={actionButtonClassName}
        />
      </label>
      <Hint hint={hint} icon={hintIcon} disabled={disabled} error={activeError} />
      {activeError && (
        <p className={cn('pt-2 text-left text-sm text-danger-500', errorClassName)}>
          {activeError}
        </p>
      )}
    </div>
  );
};

export default Input;
